<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 via-white to-blue-100">
    <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center">
      <h2 class="text-2xl font-bold text-gray-800 mb-4">Registration Closed</h2>
      <p class="text-gray-600 mb-6">
        Public registration is not available.<br>
        Please <a href="mailto:info@yourdomain.com" class="text-purple-600 underline">contact us</a> to request access.
      </p>
      <RouterLink to="/login" class="text-purple-600 hover:underline">Back to Sign In</RouterLink>
    </div>
  </div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
</script>